import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { forkJoin, of } from 'rxjs';
import { LoadingState } from '@core/utils/repository/loading_state';
import { R } from '@core/utils/r';
import { OrgId } from '@business/entities/organization';

export class ProposalsPageBloc extends BaseBloc {
  private readonly proposalBloc = resolve(Blocs.proposal);
  private readonly userBloc = resolve(Blocs.user);
  loading = new LoadingState();

  proposals$ = this.proposalBloc.proposals$;
  readonly users$ = this.userBloc.staff$;

  constructor(private readonly orgId?: OrgId) {
      super();
    }

  onInit() {
    return forkJoin(this.proposalBloc.fetchProposals()).pipe(this.loading.run());
  }

  onSearch = (search: string) => {
    this.proposalBloc.fetchProposals({ search }).subscribe();
  };

  onDebouncedSearch = R.debounce(this.onSearch, 200);

  onReload = () => {
    return this.proposalBloc.fetchProposals();
  };

  updateStatus = this.proposalBloc.updateStatus;
  updateTitle = this.proposalBloc.updateTitle;
  deleteProposal = this.proposalBloc.deleteProposal;
  unarchiveProposal = this.proposalBloc.unarchiveProposal;
}
